import React from 'react'
import { RowButton } from 'components/atoms'
import { ProductCollectionIsStandaloneBadge } from 'domains/product-collection/atoms'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'

const productCollectionTableColumns = ({ handleSelectRow }) => {

  const IsStandaloneCell = (row) => {
    const isStandalone =  row.cell.value ? 'yes' : 'no'
    return  <ProductCollectionIsStandaloneBadge isStandalone={ isStandalone } />
  }
  const UrlCell = (row) => (
    <a
      className='text-primary'
      href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/collections/${row.cell.value}` }
      target='_blank' rel='noopener noreferrer'
    >
      { `/collections/${row.cell.value}` }
    </a>
  )

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      className='w-100'
      color='primary'
      onClick={ handleSelectRow }
      text='Detail'
    />
  )

  return (
    [
      {
        Header         : 'ID',
        accessor       : 'id',
        disableFilters : true
      },
      {
        Header   : 'Name',
        accessor : 'name'
      },
      {
        Header   : 'URL',
        accessor : 'url',
        Cell     : UrlCell
      },
      {
        Header         : 'Is Standalone?',
        accessor       : 'is_standalone_page',
        disableFilters : true,
        Cell           : IsStandaloneCell
      },
      {
        Header         : 'Action',
        accessor       : 'action',
        disableFilters : true,
        Cell           : ActionCell
      }
    ]
  )
}

export default productCollectionTableColumns
